"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLicenseVisualStatus = void 0;
var format_date_1 = require("./format-date");
var MS_IN_DAY = 1000 * 60 * 60 * 24;
var getLicenseVisualStatus = function (_a) {
    var licenseStatus = _a.licenseStatus, licenseExpireDate = _a.licenseExpireDate;
    if (!licenseExpireDate) {
        return {
            level: 'NO_ACTIVE',
            daysLeft: null,
            expireDate: null,
            expireDateFormatted: null,
        };
    }
    var expireDate = licenseExpireDate instanceof Date ? licenseExpireDate : new Date(licenseExpireDate);
    if (Number.isNaN(expireDate.getTime())) {
        return {
            level: 'NO_ACTIVE',
            daysLeft: null,
            expireDate: null,
            expireDateFormatted: null,
        };
    }
    var today = new Date();
    var expireAtMidnight = new Date(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
    var todayAtMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var diffMs = expireAtMidnight.getTime() - todayAtMidnight.getTime();
    var daysLeft = Math.ceil(diffMs / MS_IN_DAY);
    if (daysLeft <= 0 || licenseStatus === 'EXPIRED' || licenseStatus === 'PENDING') {
        return {
            level: 'NO_ACTIVE',
            daysLeft: daysLeft,
            expireDate: expireDate,
            expireDateFormatted: (0, format_date_1.formatDate)(expireDate.toISOString()),
        };
    }
    var level = 'GREEN';
    if (daysLeft <= 14) {
        level = 'RED';
    }
    else if (daysLeft <= 30) {
        level = 'ORANGE';
    }
    else if (daysLeft <= 60) {
        level = 'YELLOW';
    }
    else {
        level = 'GREEN';
    }
    return {
        level: level,
        daysLeft: daysLeft,
        expireDate: expireDate,
        expireDateFormatted: (0, format_date_1.formatDate)(expireDate.toISOString()),
    };
};
exports.getLicenseVisualStatus = getLicenseVisualStatus;
